import { render, staticRenderFns } from "./requestReceiptModal.vue?vue&type=template&id=2b7331a5&scoped=true&"
import script from "./requestReceiptModal.vue?vue&type=script&lang=js&"
export * from "./requestReceiptModal.vue?vue&type=script&lang=js&"
import style0 from "./requestReceiptModal.vue?vue&type=style&index=0&id=2b7331a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7331a5",
  null
  
)

export default component.exports